export default __webpack_public_path__ + "static/media/bank-linepay.0a7ed040.svg";